module.exports = __webpack_public_path__ + "img/20190828162602360截图20190828160630404.ff0dc62b.jpg";